import { notificationDanger } from '@/utils/notification'
import { apiGetAuth, apiPostAuthWithResponseType } from '@/utils/api'
import { API_FREE_GIFT_REPORT } from '@/utils/api-url'
import { exportXLSX } from '@/utils/helper'

const state = () => {
  return {
    free_gift: { data: [] },
    detail_free_gift: { data: [] },
    meta_filter: {},
    data_modal_add_edit: {},
    toggle_modal_add_edit_discard: {
      targetModals: false,  
      title: '', 
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loadingTable: false,
      loadingPopUp: false
    }
  }
}

const mutations = {
  SET_FREE_GIFT (state, payload) {
    state.free_gift = payload
  },
  SET_DETAIL_FREE_GIFT (state, payload) {
    state.detail_free_gift = payload
  },
  SET_DATA_MODAL_ADD_EDIT (state, payload){
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD (state, payload) {
    state.toggle_modal_add_edit_discard = payload
  },
  SET_META_FILTER (state, payload) {
    state.meta_filter = payload
  }
}

const actions = {
  async getListFreeGift (context, payload) {
    const newPayload = {
      ...payload,
      sort_by: undefined,
      search: undefined
    }
    try {
      const response = await apiGetAuth(API_FREE_GIFT_REPORT.LIST_FREE_GIFT, newPayload)
      context.commit('SET_FREE_GIFT', response.data.data)
      context.commit('SET_META_FILTER', payload)
    } catch (error){
      notificationDanger(error)
    }
  },
  async getDetailFreeGift (context, payload) {
    try {
      const response = await apiGetAuth(API_FREE_GIFT_REPORT.DETAIL_FREE_GIFT(payload.id), payload.reqBody)
      context.commit('SET_DETAIL_FREE_GIFT', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async exportFreeGift(context, payload) {
    const param = '?' + new URLSearchParams(payload).toString()
    try {
      const response = await apiPostAuthWithResponseType(API_FREE_GIFT_REPORT.EXPORT_FREE_GIFT(param), 'blob')
      exportXLSX(response.data, 'export_free_gift')
      return response.data
    } catch (error) {
      notificationDanger(error)
    }
  }
}

const getters = {
  list_free_gift (state) {
    return state.free_gift
  },
  detail_free_gift (state) {
    return state.detail_free_gift
  },
  get_toggle_modal_add_edit_discard (state) {
    return state.toggle_modal_add_edit_discard
  },
  get_data_modal_add_edit (state) {
    return state.data_modal_add_edit
  },
  meta_filter (state) {
    return state.meta_filter
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
